module.exports = __webpack_public_path__ + "static/media/no-circle-violet.6574e3dd.png";